import { allSwitchers } from '@/store/switchers/switchers'

function getInitialSwitcherState() {
  const res = {
    sw_rep_strategy: 'on',
    sw_rep_ev: 'off',
    sw_rep_eq: 'off',
    sw_rep_eqr: 'off',
    sw_tabs_study: 'strategy',
    sw_tabs_strategy: 'strategy',
    sw_tabs_handmatrix: 'hands',
    sw_tabs_handmatrix_icm_events: 'hands',
    sw_tabs_actions: 'actions',
    sw_tabs_actions_reports: 'actions',
    sw_tabs_tabletile: 'poker_table_tile',
    sw_tabs_tabletile_icm_events: 'poker_table_tile',
    sw_tabs_reports_tabletile: 'poker_table_tile',
    sw_tabs_reports: 'cards',
    sw_tabs_reports_all: 'cards',
    sw_study_strategy_fullscreen: 'off',
    sw_study_range_fullscreen: 'off',
    sw_study_breakdown_fullscreen: 'off',
    sw_study_reports_fullscreen: 'off',
    sw_study_filter_intersection: 'swv_filter_intersection',
    sw_study_range_center: 'strategy',
    sw_layout_study: 'swv_layout_horizontal',
    sw_layout_spacing_study: 'swv_layout_spacing_medium',
    sw_tabs_handmatrix_all: 'hands',
    sw_tabs_handmatrix_all_icm_events: 'hands',
    sw_combos_columns: 'swv_combos_vertical',
    sw_range_height: 'swv_range_normalized',
    sw_combos_chart_style: 'swv_combos_chart_no_line',
    sw_actions_grouping: 'swv_grouping_none',
    sw_range_length: 'swv_full_length',
    sw_range_compare: 'swv_eq_buckets_simple',
    sw_range_content_hero: 'swv_range',
    sw_range_content_opponent: 'swv_range',
    sw_hand_content: 'swv_overview_all',
    sw_reports_flop_grouping: 'swv_flops',
    sw_reports_turn_grouping: 'swv_turns',
    sw_reports_flop_content: 'swv_flop_chart',
    sw_reports_turn_content: 'swv_turn_cells',
    sw_reports_colorcoding01: 'swv_reports_colortext_colorchart',
    sw_combos_dialog_content: 'swv_handmatrix',
    sw_handmatrix: 'swv_handmatrix_detailed',
    sw_blockers_dialog_content: 'swv_table_all_summary',
    sw_trainer_result_chart: 'swv_trainer_result_grid',
    sw_rangebuilder_handmatrix: 'hands',
    sw_rangebuilder_handmatrix_all: 'strategy',
    sw_ev_converter: 'ev',
    sw_ev_icm_converter: 'csd',
  }
  return res
}
function getInitialState() {
  const res = {}
  const defaultState = getInitialSwitcherState()
  let localState = {}
  try {
    localState = JSON.parse(localStorage.getItem('switchers')) || {}
  } catch (error) {
    //
  }

  const all = allSwitchers()
  Object.keys(defaultState).forEach(key => {
    const conf = all[key]
    const l_value = localState?.[key]
    if (!conf || !conf.some(i => i.payload === l_value)) {
      res[key] = defaultState[key]
    } else {
      res[key] = localState[key]
    }
  })

  return res
}

const actions = {
  switchers_initialize({ state, dispatch, commit, getters }) {
    const all = allSwitchers()
    Object.keys(state).forEach(key => {
      const conf = all[key]
      if (conf) {
        const item = conf.find(i => i.payload === state[key])
        if (item?.fn) {
          item.fn({ state, dispatch, commit, getters })
        }
      }
    })
  },
  switchers_set_defaults({ state, dispatch, commit, getters }) {
    const defaults = getters.mergedUserSettings.switchersDefaults
    Object.keys(defaults).forEach(key => {
      if (defaults[key]) {
        commit('switchers_set', { key, value: defaults[key] })
      }
    })
  },
  switchers_set_item_by_value({ state, dispatch, commit, getters }, { key, value }) {
    const all = allSwitchers()
    const conf = all[key]
    const item = conf.find(i => i.payload === value)
    dispatch('switchers_set_item', {
      key,
      item,
    })
  },
  switchers_set_next({ state, dispatch, commit, getters }, { key, num = 1 }) {
    const nextItem = getters.switchers_getNext({ key, num })
    dispatch(`switchers_set_item`, {
      key,
      item: nextItem,
    })
  },
  switchers_set_item({ state, dispatch, commit, getters }, { key, item }) {
    if (item.fn) {
      item.fn({ state, dispatch, commit, getters })
    }
    commit('switchers_set', { key, value: item.payload })
  },
}

const getters = {
  switchers_get: state => key => state[key],
  switchers_getNext:
    (state, getters, rootState, rootGetters) =>
    ({ key, num = 1 }) => {
      const all = allSwitchers()
      const conf = all[key]
      const currValue = state[key]
      const idx = conf.findIndex(i => i.payload === currValue)
      const nextItem = conf[idx + num] || (num === 1 ? conf[0] : conf[conf.length - 1])
      return nextItem
    },
  sw_rep_strategy: state => state.sw_rep_strategy,
  sw_rep_ev: state => state.sw_rep_ev,
  sw_rep_eq: state => state.sw_rep_eq,
  sw_rep_eqr: state => state.sw_rep_eqr,
  sw_tabs_study: state => state.sw_tabs_study,
  sw_tabs_strategy: state => state.sw_tabs_strategy,
  sw_tabs_handmatrix: state => state.sw_tabs_handmatrix,
  sw_tabs_handmatrix_icm_events: state => state.sw_tabs_handmatrix_icm_events,
  sw_tabs_actions: state => state.sw_tabs_actions,
  sw_study_range_center: state => state.sw_study_range_center,
  sw_tabs_actions_reports: state => state.sw_tabs_actions_reports,
  sw_tabs_tabletile: state => state.sw_tabs_tabletile,
  sw_tabs_tabletile_icm_events: state => state.sw_tabs_tabletile_icm_events,
  sw_tabs_reports_tabletile: state => state.sw_tabs_reports_tabletile,
  sw_tabs_reports: state => state.sw_tabs_reports,
  sw_tabs_reports_all: state => state.sw_tabs_reports_all,
  sw_range_height: state => state.sw_range_height,
  sw_combos_chart_style: state => state.sw_combos_chart_style,
  sw_combos_columns: state => state.sw_combos_columns,
  sw_study_strategy_fullscreen: state => state.sw_study_strategy_fullscreen,
  sw_study_range_fullscreen: state => state.sw_study_range_fullscreen,
  sw_study_breakdown_fullscreen: state => state.sw_study_breakdown_fullscreen,
  sw_study_reports_fullscreen: state => state.sw_study_reports_fullscreen,
  sw_study_filter_intersection: state => state.sw_study_filter_intersection,
  sw_layout_study: state => state.sw_layout_study,
  sw_layout_spacing_study: state => state.sw_layout_spacing_study,
  sw_actions_grouping: state => state.sw_actions_grouping,
  sw_tabs_handmatrix_all: state => state.sw_tabs_handmatrix_all,
  sw_tabs_handmatrix_all_icm_events: state => state.sw_tabs_handmatrix_all_icm_events,
  sw_range_length: state => state.sw_range_length,
  sw_range_compare: state => state.sw_range_compare,
  sw_range_content_hero: state => state.sw_range_content_hero,
  sw_range_content_opponent: state => state.sw_range_content_opponent,
  sw_hand_content: state => state.sw_hand_content,
  sw_reports_flop_grouping: state => state.sw_reports_flop_grouping,
  sw_reports_turn_grouping: state => state.sw_reports_turn_grouping,
  sw_reports_flop_content: state => state.sw_reports_flop_content,
  sw_reports_turn_content: state => state.sw_reports_turn_content,
  sw_combos_dialog_content: state => state.sw_combos_dialog_content,
  sw_handmatrix: state => state.sw_handmatrix,
  sw_blockers_dialog_content: state => state.sw_blockers_dialog_content,
  sw_reports_colorcoding01: state => state.sw_reports_colorcoding01,
  sw_trainer_result_chart: state => state.sw_trainer_result_chart,
  sw_rangebuilder_handmatrix: state => state.sw_rangebuilder_handmatrix,
  sw_rangebuilder_handmatrix_all: state => state.sw_rangebuilder_handmatrix_all,

  sw_ev_converter: (state, getters) => getters.show_ev_in || state.sw_ev_converter,
  sw_ev_icm_converter: (state, getters) => getters.show_ev_icm_in || state.sw_ev_icm_converter,
}

const mutations = {
  switchers_set(state, { key, value }) {
    state[key] = value
    const persistKeys = [
      'sw_rep_strategy',
      'sw_rep_ev',
      'sw_rep_eq',
      'sw_rep_eqr',
      'sw_tabs_study',
      'sw_tabs_strategy',
      'sw_tabs_handmatrix',
      'sw_tabs_handmatrix_icm_events',
      'sw_tabs_actions',
      'sw_tabs_actions_reports',
      'sw_tabs_tabletile',
      'sw_tabs_tabletile_icm_events',
      'sw_tabs_reports_tabletile',
      'sw_tabs_reports',
      'sw_tabs_reports_all',
      'sw_study_strategy_fullscreen',
      'sw_study_range_fullscreen',
      'sw_study_breakdown_fullscreen',
      'sw_study_reports_fullscreen',
      'sw_study_filter_intersection',
      'sw_study_range_center',
      'sw_tabs_handmatrix_all',
      'sw_tabs_handmatrix_all_icm_events',
      'sw_layout_study',
      'sw_layout_spacing_study',
      'sw_combos_columns',
      'sw_combos_chart_style',
      'sw_range_height',
      'sw_range_length',
      'sw_range_compare',
      'sw_actions_grouping',
      'sw_range_content_hero',
      'sw_range_content_opponent',
      'sw_reports_flop_grouping',
      'sw_reports_turn_grouping',
      'sw_reports_flop_content',
      'sw_reports_turn_content',
      'sw_reports_colorcoding01',
      'sw_combos_dialog_content',
      'sw_handmatrix',
      'sw_blockers_dialog_content',
      'sw_trainer_result_chart',
      'sw_rangebuilder_handmatrix',
      'sw_rangebuilder_handmatrix_all',
      'sw_hand_content',
      'sw_ev_converter',
      'sw_ev_icm_converter',
    ]
    if (persistKeys.some(k => k === key)) {
      const persistVals = {}
      persistKeys.forEach(k => {
        persistVals[k] = state[k]
      })
      localStorage.setItem('switchers', JSON.stringify(persistVals))
    }

    // back compatibility till 05/2020
    // - study_range_length >> sw_range_length |
    // --full_length, range_length >> swv_full_length, swv_range_length

    // - study_grouping_switcher
    // --none, groups_4, grouped_bets
  },
}

export default {
  state: getInitialState({ omitKeys: {} }),
  getters,
  actions,
  mutations,
}
